import { render, staticRenderFns } from "./NetworkEndpoints.vue?vue&type=template&id=0563c7be&scoped=true&"
import script from "./NetworkEndpoints.vue?vue&type=script&lang=js&"
export * from "./NetworkEndpoints.vue?vue&type=script&lang=js&"
import style0 from "./NetworkEndpoints.vue?vue&type=style&index=0&id=0563c7be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0563c7be",
  null
  
)

export default component.exports